import React from 'react';
import { func, bool } from 'prop-types';
import {
  OverlayCustomStyles,
  ReactModal,
  MaterialButton,
  Container,
  Heading,
  GDPRComponents,
  ButtonContainer,
  CopyWrapper,
} from './styles';

export class MarketingModal extends React.PureComponent {
  render() {
    return (
      <Container>
        <ReactModal
          isOpen={this.props.showModal}
          style={OverlayCustomStyles}
          onRequestClose={this.props.toggleModal}
          shouldCloseOnOverlayClick
        >
          <CopyWrapper>
            <Heading>Your marketing preferences</Heading>
            <p>
              You can visit your{' '}
              <GDPRComponents href="/u/marketing-preferences" target="_blank">
                Marketing Preferences Centre
              </GDPRComponents>{' '}
              at any time to update your email and post preferences. If you make no changes, we will
              leave your preferences as they are for now.
            </p>
            <p>
              We have updated our{' '}
              <GDPRComponents href="/about/privacy" target="_blank">
                Privacy Policy
              </GDPRComponents>{' '}
              in line with data protection laws.
            </p>
          </CopyWrapper>
          <ButtonContainer>
            <MaterialButton
              type="submit"
              size="medium"
              data-privacy-policy-accept-button
              onClick={this.props.toggleModal}
            >
              Ok, got it!
            </MaterialButton>
          </ButtonContainer>
        </ReactModal>
      </Container>
    );
  }
}

MarketingModal.propTypes = {
  toggleModal: func.isRequired,
  showModal: bool,
};

MarketingModal.defaultProps = {
  showModal: false,
};

export default MarketingModal;
